export const GENERIC_API_ERROR_MESSAGE =
  'Something wrong happened, please try again later';

export function isFailedApiResponse(response: { status?: boolean } | null | undefined): boolean {
  return response?.status === false;
}

export function extractApiErrorMessage(err: any): string {
  const body = err?.error ?? err;

  if (err?.error?.status_code == 422 || err?.status == 422) {
    const validationMessage = firstValidationMessage(err?.error?.error);
    if (validationMessage) {
      return validationMessage;
    }
  }

  const apiMessage = usableString(body?.message);
  if (apiMessage) {
    return apiMessage;
  }

  if (err?.status == 400) {
    const errorField = usableString(body?.error);
    if (errorField) {
      return errorField;
    }
  }

  return GENERIC_API_ERROR_MESSAGE;
}

function firstValidationMessage(errors: unknown): string | null {
  if (!errors || typeof errors !== 'object') {
    return usableString(errors);
  }

  const keys = Object.keys(errors);
  if (!keys.length) {
    return null;
  }

  const first = (errors as Record<string, unknown>)[keys[0]];
  if (Array.isArray(first)) {
    return usableString(first[0]);
  }

  return usableString(first);
}

function usableString(value: unknown): string | null {
  if (typeof value !== 'string') {
    return null;
  }

  const trimmed = value.trim();
  return trimmed ? trimmed : null;
}
